(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').run(['CustomModuleRunService', customRun]);

    function customRun(CustomModuleRunService) {
        CustomModuleRunService.add([
            '$transitions',
            'PersistentWarningService',
            SetupPersistentWarningService,
        ]);
    }

    function SetupPersistentWarningService(
        $transitions,
        PersistentWarningService
    ) {
        $transitions.onSuccess({}, function clearPersistentWarnings() {
            // clear persistent warnings that have no timeout, so they don't stay there forever
            PersistentWarningService.clear();
        });
    }

})(window.angular);
